<template>
    <div class="legal-wrapper">
        <div class="terms-policy">
            <div class="policy-title">{{ title }}</div>
            <div class="policy-text" v-html="content"></div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'Terms',
        data() {
            return {
                slug: '',
                title: '',
                content: ''
            }
        },
        async created() {
            this.slug = this.getSlugFromURL()
            this.loadContent()
        },
        methods: {
            getSlugFromURL() {
                const urlSegments = window.location.href.split('/')
                return urlSegments[urlSegments.length - 1]
            },
            async loadContent() {
                const response = await axios.get(this.getContentURL())
                const contentData = response.data.data.sections[0].content
                this.title = contentData.title
                this.content = contentData.description
            },
            getContentURL() {
                const contentURLs = {
                    'terms-of-service': '/terms-of-service-response',
                    'refunds-and-cancellation-policy':
                        '/refunds-and-cancellation-policy-response',
                    'privacy-policy': '/privacy-policy-response',
                    'payment-terms': '/payment-terms-response',
                    'dispute-resolution-policy': '/dispute-resolution-policy-response',
                    'off-platform-policy': '/off-platform-policy-response'
                }
                return contentURLs[this.slug]
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .legal-wrapper {
        display: flex;
        background: #000;
        box-shadow: 0px 24px 48px -8px rgba(0, 0, 0, 0.4), 0px 0px 1px 0px rgba(0, 0, 0, 0.6);
        justify-content: center;
    }
    .terms-policy {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-basis: 50%;
    }
    .policy-title {
        color: #dedede;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
        margin-bottom: 90px;
    }
    .policy-text {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    @media only screen and (max-width: 768px) {
        .terms-policy {
            flex: 1;
            padding: 10px;
        }
        .policy-title {
            margin-bottom: 50px;
        }
    }
</style>
